<template>
  <a-card :bordered="false" :style="{ height: '100%' }">
    <a-row :gutter="24">
      <a-col :md="18" :offset="6">
        <div style="max-width: 800px">
          <a-divider v-if="false" />
          <div v-if="mdl.id">
            <h3 v-if="false">角色：{{ mdl.name }}</h3>
          </div>
          <a-form :form="form" :layout="'horizontal'">
            <a-form-item label="权限组名称" v-show="false">
              <a-input v-decorator="[ 'id' ]" placeholder="请填写权限组名称" />
            </a-form-item>
            <a-form-item label="权限组名称">
              <a-input v-decorator="[ 'name', {rules: [{ required: true, message: 'Please input a-role name!' }]} ]" placeholder="请填写权限组名称" />
            </a-form-item>

            <a-form-item label="站点">
              <a-select v-decorator="[ 'site', {rules: []} ]" disabled>
                <a-select-option :value="1">管理端</a-select-option>
                <a-select-option :value="2">企业端</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="备注说明">
              <a-textarea :row="3" v-decorator="[ 'description', {rules: [{ required: false, message: 'Please input a-role name!' }]} ]" placeholder="请填写权限组名称" />
            </a-form-item>

            <a-form-item label="拥有权限">
              <a-row v-if="false" :gutter="16" v-for="(permission, index) in permissions" :key="index+1">
                <a-col :xl="4" :lg="24">
                  {{ permission.name }}：
                </a-col>
                <a-col :xl="20" :lg="24">
                  <a-checkbox
                    v-if="permission.actionsOptions.length > 0"
                    :indeterminate="permission.indeterminate"
                    :checked="permission.checkedAll"
                    @change="onChangeCheckAll($event, permission)">
                    全选
                  </a-checkbox>
                  <a-checkbox-group :options="permission.actionsOptions" v-model="permission.selected" @change="onChangeCheck(permission)" />
                </a-col>
              </a-row>
              <a-row v-if="groupPermissions !== undefined" :gutter="16" v-for="(permissions, key) in groupPermissions" :key="permissions.id">
                <a-divider orientation="left">
                  {{ site_group[key] }}
                </a-divider>
                <a-row v-if="true" :gutter="16" v-for="(permission, index) in permissions" :key="index+1">
                  <a-col :xl="4" :lg="24">
                    {{ permission.name }}：
                  </a-col>
                  <a-col :xl="20" :lg="24">
                    <a-checkbox
                      v-if="permission.actionsOptions.length > 0"
                      :indeterminate="permission.indeterminate"
                      :checked="permission.checkedAll"
                      @change="onChangeCheckAll($event, permission)">
                      全选
                    </a-checkbox>
                    <a-checkbox-group :options="permission.actionsOptions" v-model="permission.selected" @change="onChangeCheck(permission)" />
                  </a-col>
                </a-row>
              </a-row>
            </a-form-item>

            <a-form-item>
              <a-row>
                <a-col span="6">
                  <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
                </a-col>
                <a-col span="10">
                  <a-button @click="handleGoBack">返回</a-button>
                </a-col>
                <a-col span="8"></a-col>
              </a-row>
            </a-form-item>
          </a-form>
        </div>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import pick from 'lodash.pick'
import { baseMixin } from '@/store/app-mixin'
import { permission_group_list, permission_group_update } from '@/api/permission_group'
import { defaultCorporationPermissions, permissionNoPager } from '@/views/a-role/table/role'
import { corporation_config_list } from '@/api/corporation'
import { Dictionaries } from '@/common/AllConstant'

export default {
  name: 'RoleList',
  mixins: [baseMixin],
  components: {},
  props: {
    // record: {
    //   type: [Object, String],
    //   default: ''
    // }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      mdl: {},
      record: {},
      roles: [],
      permissions: [],
      type: 0,
      groupPermissions: undefined,
      corporation_permission_group: this.$Dictionaries.corporation_permission_group,
      site_group: undefined
    }
  },
  created () {
    permission_group_list({ site: 2, id: this.$route.params.id }).then((res) => {
      var result = {
        entries: res.data || []
      }
      result.entries.forEach((item) => {
        // eslint-disable-next-line no-eval
        item.permissions = eval(item.view_json)
      })
      if (result && result.entries.length > 0) {
        this.record = result.entries[0]
        console.log(this.record, '我是穿过的数据')
        const site = this.record.site
        if (site === 1) {
          this.loadCorporationPermissions()
        }
        if (site === 2) {
          this.loadCorporationPermissions()
          console.log('====>>>', this.permissions)
          this.permissions = this.permissions.filter((item) => {
            return item.site === 'corporation'
          })
        }
      }
    })
  },
  methods: {
    handleSubmit () {
      const form = this.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          const rolepermissons = this.permissions.map((item) => {
            return {
              roleId: values.id,
              permissionId: this.type === 1 ? item.permissionId : item.id,
              permissionName: item.name,
              actions: item.actionData,
              actionEntitySet: item.actionsOptions.map((i) => {
                if (item.selected.indexOf(i.value) !== -1) {
                  return {
                    action: i.value,
                    description: i.label,
                    defaultCheck: true,
                    pid: i.pid
                  }
                } else {
                  return {
                    action: i.value,
                    description: i.label,
                    defaultCheck: false
                  }
                }
              }),
              actionList: item.selected,
              dataAccess: null
            }
          })
          const actionEntitySetlist = rolepermissons.map((item) => {
            return item.actionEntitySet
          })
          const flatactionEntitySetlist = actionEntitySetlist.flat().map((item) => {
            return item.pid
          })
          const permission_ids = flatactionEntitySetlist.filter((item) => {
            return item
          })
          const rolepermissons_filter = rolepermissons.filter((item) => {
            return item.actionList.length > 0
          })
          console.log(rolepermissons_filter, '-------')
          const endData = JSON.stringify(rolepermissons_filter)
          const params = Object.assign({}, values, { view_json: endData, permission_ids: permission_ids })
          // 新增
          permission_group_update(params, values.id).then(res => {
            this.visible = false
            this.confirmLoading = false
            // 重置表单数据
            form.resetFields()
            // 刷新表格
            this.handleGoBack()
          }, (errors) => {
            this.confirmLoading = false
          }).finally(() => {
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    },

    handleGoBack () {
      // this.$emit('onGoBack')
      this.$router.go(-1)
    },
    callback (val) {
      console.log(val)
    },
    edit (record) {
      this.mdl = Object.assign({}, record)
      // 有权限表，处理勾选
      if (this.mdl.permissions && this.permissions) {
        // 先处理要勾选的权限结构
        const permissionsAction = {}
        console.log(this.mdl.permissions)
        this.mdl.permissions.forEach(permission => {
          const id = permission.permissionId ? permission.permissionId : permission.id
          permissionsAction[id] = permission.actionList
        })
        // 把权限表遍历一遍，设定要勾选的权限 action
        console.log('--------------', permissionsAction)
        this.permissions.forEach(permission => {
          console.log('--------------', permission)
          const id = permission.permissionId ? permission.permissionId : permission.id
          const selected = permissionsAction[id]
          permission.selected = selected || []
          this.onChangeCheck(permission)
        })
      }

      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.mdl, 'id', 'name', 'site', 'description'))
      })
    },
    onChangeCheck (permission) {
      permission.indeterminate = !!permission.selected.length && (permission.selected.length < permission.actionsOptions.length)
      permission.checkedAll = permission.selected.length === permission.actionsOptions.length
    },
    onChangeCheckAll (e, permission) {
      Object.assign(permission, {
        selected: e.target.checked ? permission.actionsOptions.map(obj => obj.value) : [],
        indeterminate: false,
        checkedAll: e.target.checked
      })
    },
    loadPermissions () {
      this.permissions = permissionNoPager.map(permission => {
        const options = JSON.parse(permission.actionData)
        permission.checkedAll = false
        permission.selected = []
        permission.indeterminate = false
        permission.actionsOptions = options.map(option => {
          return {
            label: option.description,
            value: option.action,
            pid: option.pid
          }
        })
        return permission
      })
    },
    // 获取企业专有菜单
    loadCorporationPermissions () {
      corporation_config_list(Dictionaries.corporation_id).then((res) => {
        const result = res.data.max_permission
        console.log('=====-----', result.length)
        // eslint-disable-next-line no-eval
        const myresult = eval(result)
        if (result && myresult.length > 0) {
          // type = 1,获取后台设置的针对当前企业的最大权限
          this.type = 1
          this.permissions = myresult.map(permission => {
            const options = JSON.parse(permission.actions)
            // eslint-disable-next-line no-eval
            // const options = eval(permission.actions)
            permission.name = permission.permissionName
            permission.checkedAll = false
            permission.selected = []
            permission.indeterminate = false
            permission.actionsOptions = options.map(option => {
              return {
                label: option.description,
                value: option.action,
                pid: option.pid
              }
            }).filter((option) => {
              console.log(permission.actionList, option.value, permission.actionList.indexOf(option.action))
              return permission.actionList.indexOf(option.value) > -1
            })
            return permission
          })
        } else {
          console.log('=====')
          // type = 1,本地设置的最大权限
          this.type = 2
          this.permissions = defaultCorporationPermissions.map(permission => {
            const options = JSON.parse(permission.actionData)
            // permission.permissionName = permission.name
            permission.checkedAll = false
            permission.selected = []
            permission.indeterminate = false
            permission.actionsOptions = options.map(option => {
              return {
                label: option.description,
                value: option.action,
                pid: option.pid
              }
            })
            return permission
          })
          this.permissions = this.permissions.filter((item) => {
            return item.site === 'corporation'
          })
          console.log(this.permissions)
        }
      }).finally(() => {
        const groupBy = (array, key) => {
          return array.reduce((result, currentItem) => {
            // 使用 key 函数提取分组键，如果是字符串属性可以直接使用
            const groupKey = typeof key === 'function' ? key(currentItem) : currentItem[key]

            // 确保 result 对象中有对应分组的数组
            if (!result[groupKey]) {
              result[groupKey] = []
            }
            // 将当前项添加到对应分组的数组中
            result[groupKey].push(currentItem)

            return result
          }, {})
        }
        this.groupPermissions = groupBy(this.permissions, 'description')
        this.site_group = this.corporation_permission_group
        this.edit(this.record)
      })
    }
  }
}
</script>

<style scoped>

</style>
